var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSampleGroupProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3f7ff;}.b{opacity:0.75;}.c{fill:#c1d4f8;}.d{fill:#9dbafc;}.e{opacity:0.3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -379)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(18 379)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(22.761 393.601)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.318,0a3.527,3.527,0,1,0,3.527,3.527A3.536,3.536,0,0,0,114.318,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.3,250.407a3.288,3.288,0,0,0-.354-.647,4.384,4.384,0,0,0-3.034-1.91.649.649,0,0,0-.447.108,3.759,3.759,0,0,1-4.436,0,.578.578,0,0,0-.447-.108,4.352,4.352,0,0,0-3.034,1.91,3.792,3.792,0,0,0-.354.647.328.328,0,0,0,.015.293,6.142,6.142,0,0,0,.416.616,5.855,5.855,0,0,0,.708.8,9.23,9.23,0,0,0,.708.616,7.023,7.023,0,0,0,8.378,0,6.771,6.771,0,0,0,.708-.616,7.113,7.113,0,0,0,.708-.8,5.4,5.4,0,0,0,.416-.616A.263.263,0,0,0,36.3,250.407Z",
    transform: "translate(-24.165 -247.841)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(44.014 393.601)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M114.318,0a3.527,3.527,0,1,0,3.527,3.527A3.536,3.536,0,0,0,114.318,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.3,250.407a3.288,3.288,0,0,0-.354-.647,4.384,4.384,0,0,0-3.034-1.91.649.649,0,0,0-.447.108,3.759,3.759,0,0,1-4.436,0,.578.578,0,0,0-.447-.108,4.352,4.352,0,0,0-3.034,1.91,3.792,3.792,0,0,0-.354.647.328.328,0,0,0,.015.293,6.142,6.142,0,0,0,.416.616,5.855,5.855,0,0,0,.708.8,9.23,9.23,0,0,0,.708.616,7.023,7.023,0,0,0,8.378,0,6.771,6.771,0,0,0,.708-.616,7.113,7.113,0,0,0,.708-.8,5.4,5.4,0,0,0,.416-.616A.263.263,0,0,0,36.3,250.407Z",
    transform: "translate(-24.165 -247.841)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.788 389.626)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M116.5,0a5.708,5.708,0,1,0,5.708,5.708A5.723,5.723,0,0,0,116.5,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.824)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M43.8,251.994a5.322,5.322,0,0,0-.573-1.047,7.1,7.1,0,0,0-4.91-3.091,1.051,1.051,0,0,0-.723.175,6.084,6.084,0,0,1-7.179,0,.935.935,0,0,0-.723-.175,7.043,7.043,0,0,0-4.91,3.091,6.137,6.137,0,0,0-.573,1.047.53.53,0,0,0,.025.474,9.943,9.943,0,0,0,.673,1,9.475,9.475,0,0,0,1.147,1.3,14.941,14.941,0,0,0,1.147,1,11.367,11.367,0,0,0,13.56,0,10.959,10.959,0,0,0,1.147-1,11.512,11.512,0,0,0,1.147-1.3,8.738,8.738,0,0,0,.673-1A.425.425,0,0,0,43.8,251.994Z",
    transform: "translate(-24.165 -247.841)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleGroupProfile);
export default __webpack_public_path__ + "static/media/sample-group-profile.f81f7049dcc86adb5483db5617ccf03d.svg";
export { ForwardRef as ReactComponent };